export default class commentHelper {
    static spaceRegex = /(\s+)/g;

    static noBreakingSpace = '&nbsp';

    static htmlNewLineTaq = '<br>';

    static htmlToPainText(HTMLContent) {
        const decoder = (childNode) => {
            if (childNode.tagName === 'A') {
                return childNode.title;
            }
            const text = childNode.textContent || childNode.innerText || '';
            if (childNode.tagName === 'DIV' || childNode.tagName === 'BR') {
                return `\n${childNode.title}`;
            }
            if (text === commentHelper.noBreakingSpace) {
                return ' ';
            }
            return text;
        };
        return [...HTMLContent.childNodes].map(decoder).join('');
    }

    static plainTextToChunks(comment, providers, processor) {
        const commentChunks = comment.split(commentHelper.spaceRegex);
        return commentChunks.map((chunk) => {
            if (/\n/.test(chunk)) {
                return processor.newLine();
            }
            if (/\s/.test(chunk)) {
                return processor.whiteSpace();
            }
            const provider = providers.find(({regex}) => chunk.match(regex));

            // no provider
            if (!provider) {
                return processor.word(chunk);
            }

            // static action (constant)
            if (provider.staticValues
                && !!provider.staticValues.find(val => val.value === chunk)) {
                // render static action
                // TODO static without the resourceMask?
                const {match, id} = provider.resourceMask(chunk, provider);
                return processor.action({
                    name: match,
                    text: id,
                });
            }

            return processor.resource(chunk, provider);
        });
    }

    static plainTextToObjects(comment, providers, resourceProcessor) {
        const processor = {
            newLine: () => (
                {
                    type: 'divider',
                    text: commentHelper.htmlNewLineTaq,
                }
            ),
            whiteSpace: () => (
                {
                    type: 'divider',
                    text: commentHelper.noBreakingSpace,
                }
            ),
            word: word => (
                {
                    type: 'text',
                    text: word,
                }
            ),
            action: ({name, text}) => ({
                type: 'action',
                name,
                text,
            }),
            resource: (provider, chunk) => (
                {
                    type: 'resource',
                    ...resourceProcessor(provider, chunk),
                }
            ),
        };
        return commentHelper.plainTextToChunks(comment, providers, processor);
    }

    static plainTextToEditableHTML(comment, providers) {
        const resourceProcessor = (chunk, provider) => {
            const {match, id} = provider.resourceMask(chunk, provider);
            return {text: `<a title='${match}' contenteditable='false'>${id}</a>`};
        };
        return commentHelper
            .plainTextToObjects(comment, providers, resourceProcessor)
            .map(({text}) => text).join('');
    }

    static plainTextToIterableHTML(comment, providers) {
        const resourceProcessor = (chunk, provider) => {
            const resource = provider.resourceMask(chunk, provider);
            const routeMask = provider.resources[resource.name].resourceRouteMask;
            return {
                ...resource,
                ...(routeMask ? {route: routeMask(resource)} : {}),
            };
        };
        return commentHelper
            .plainTextToObjects(comment, providers, resourceProcessor);
    }
}
